module.exports = __webpack_public_path__ + "static/media/joao_mendes.30836e5b.jpg";